<template>
    <!-- Mini-tour de 4 passos do primeiro acesso. Cada passo pede ao pai o
         flash da área correspondente; persiste em localStorage e pode ser
         reaberto pelo botão "Tour" do painel do agente. -->
    <div
        v-if="step !== null"
        class="fixed bottom-24 left-1/2 z-[90] flex w-[min(420px,calc(100vw-48px))] -translate-x-1/2 flex-col gap-2.5 rounded-xl bg-gray-950 p-4 text-white shadow-[0_16px_48px_rgba(16,16,20,0.4)]"
        role="dialog"
        aria-label="Tour da tela de métricas"
    >
        <div class="flex items-center gap-2.5">
            <span
                class="font-mono text-[10px] uppercase tracking-[0.14em] text-gray-400"
            >
                {{ step + 1 }} de {{ steps.length }}
            </span>
            <span class="text-sm font-semibold">
                {{ steps[step].title }}
            </span>
        </div>
        <p class="text-[13px] leading-relaxed text-gray-300">
            {{ steps[step].body }}
        </p>
        <div class="mt-0.5 flex items-center gap-2">
            <span
                v-for="(item, index) in steps"
                :key="index"
                class="h-1.5 w-1.5 rounded-full"
                :class="index === step ? 'bg-indigo-500' : 'bg-gray-700'"
            ></span>
            <span class="flex-1"></span>
            <button
                type="button"
                class="rounded-lg border border-gray-700 px-3 py-1.5 text-xs text-gray-400 transition-colors hover:text-white"
                @click="end"
            >
                Pular
            </button>
            <button
                type="button"
                class="rounded-lg bg-indigo-600 px-3.5 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-indigo-500"
                @click="next"
            >
                {{ step === steps.length - 1 ? "Entendi" : "Próximo" }}
            </button>
        </div>
    </div>
</template>

<script>
const STORAGE_KEY = "ticto_metricas_tour_v3";

export default {
    name: "MetricsTour",

    emits: ["highlight"],

    data() {
        return {
            step: null,
            steps: [
                {
                    key: "julg",
                    title: "Comece pelos julgamentos",
                    body: "As três perguntas do caso, com o estado de cada eixo. Clique em uma para ir direto à evidência que a sustenta.",
                },
                {
                    key: "runoff",
                    title: "A evidência vive nas seções",
                    body: "Reserva & Runoff, Conduta & Score, Operação e Histórico. Abra só o que precisa — os resumos no cabeçalho já dizem se algo exige atenção.",
                },
                {
                    key: "agent",
                    title: "Não achou um dado? Pergunte",
                    body: 'O agente abre a seção certa, rola até ela e destaca a evidência. Ex: "onde está o runoff?" ou "posso liberar o saque?".',
                },
                {
                    key: "bar",
                    title: "A decisão fica sempre aqui",
                    body: "Enquanto o caso estiver aberto, as ações e a justificativa ficam na barra do rodapé — de qualquer lugar da tela.",
                },
            ],
        };
    },

    mounted() {
        let seen = null;

        try {
            seen = localStorage.getItem(STORAGE_KEY);
        } catch (error) {
            // Sem localStorage (modo privado): não insiste no tour.
            seen = "1";
        }

        if (!seen) {
            setTimeout(() => this.go(0), 600);
        }
    },

    methods: {
        start() {
            this.go(0);
        },

        go(index) {
            if (index >= this.steps.length) {
                this.end();
                return;
            }

            this.step = index;
            this.$emit("highlight", this.steps[index].key);
        },

        next() {
            this.go(this.step + 1);
        },

        end() {
            this.step = null;
            this.$emit("highlight", null);

            try {
                localStorage.setItem(STORAGE_KEY, "1");
            } catch (error) {
                // Sem persistência o tour volta na próxima visita; aceitável.
            }
        },
    },
};
</script>
